import { AxiosError } from 'axios';

/** Turn FastAPI/axios errors into a single user-visible string. */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  const ax = err as AxiosError<{ detail?: unknown }>;
  const d = ax.response?.data?.detail;
  if (typeof d === 'string' && d.trim()) return d;
  if (Array.isArray(d)) {
    const parts = d.map((item) =>
      typeof item === 'object' && item !== null && 'msg' in item
        ? String((item as { msg: unknown }).msg)
        : JSON.stringify(item),
    );
    const joined = parts.join('; ').trim();
    if (joined) return joined;
  }
  if (d !== undefined && d !== null && typeof d === 'object') {
    try {
      return JSON.stringify(d);
    } catch {
      /* ignore */
    }
  }
  const msg = ax.message?.trim();
  if (msg && msg !== 'Network Error') return msg;
  if (!ax.response) return `${fallback} (no response from server — check network or session).`;
  return fallback;
}
